/**
 * Analytics
 * Analytics API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeviceOnlineActivity } from './device-online-activity';
import { FirmwareUpdatedActivity } from './firmware-updated-activity';
import { ProvisionedActivity } from './provisioned-activity';
import { SeverityRaisedActivity } from './severity-raised-activity';
import { SeverityResolvedActivity } from './severity-resolved-activity';
import { ActivityKind } from './activity-kind';
import { DeviceOfflineActivity } from './device-offline-activity';


export interface ActivityEvent { 
    source: string | null;
    timestamp: string;
    deviceTwistId?: string | null;
    modelIndex?: number | null;
    summary?: string | null;
    deviceName?: string | null;
    modelTypeName?: string | null;
    id: string;
    kind: ActivityKind;
    rawKind: string | null;
    rawPayload?: string | null;
    deviceOnline?: DeviceOnlineActivity;
    deviceOffline?: DeviceOfflineActivity;
    firmwareUpdated?: FirmwareUpdatedActivity;
    provisioned?: ProvisionedActivity;
    severityRaised?: SeverityRaisedActivity;
    severityResolved?: SeverityResolvedActivity;
    type: ActivityEventTypeEnum;
}
export enum ActivityEventTypeEnum {
    Activity = 'activity'
};



